import Rule from "../../../common/rule";
import FootballState from "../../../football/state/football-state";

/**
 * Spots the ball where it died. Possession and the player in possession are
 * deliberately left alone: a dead ball has no recoverer, the offense keeps the
 * ball, and FumbledSnapPossession has already recorded who muffed the snap.
 * The down advances through the ordinary ChangeDown path (ruleContext
 * .advanceDown defaults to true).
 */
export default class DeadBallFieldChange extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.DeadBall;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.setFieldPosition(fragment.deadAt);
    }
}
